import { REDUX_DEFAULT_DOMAIN_LIST_KEY } from 'modules/redux/constants'
import { CATEGORIES_DOMAIN } from 'modules/categories/constants'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import REDUX_OPTION from 'modules/redux/constants/option'
import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { getEndpointFromSectionModelUtil } from 'models/utils/get-endpoint-from-section'

/**
 * Loads the categories of a section into a SubDomain.
 * @param  {Object} props
 * @param  {Object} props.route
 * @param  {Object} props.match
 * @param  {Object} props.[options={}]
 * @returns {Promise}
 */
function loadCategoriesAction ({
  route,
  match,
  options = {}
}) {
  const { section } = route

  const endpoint = '/categories'
  const path = `${CATEGORIES_DOMAIN}.${section}`
  const domainListPath = `${path}.${REDUX_DEFAULT_DOMAIN_LIST_KEY}`
  options = {
    ...options,
    [REDUX_OPTION.SET_ALIAS]: true
  }

  return loadLegacyReduxAction({
    endpoint: `${getEndpointFromSectionModelUtil(section)}${endpoint}`,
    className: CATEGORY_MODEL_CLASS_NAME,
    path,
    domainListPath,
    options
  })
}

export {
  loadCategoriesAction
}
